import React from 'react';

import { Icon } from '@chakra-ui/react';

export const BotIcon = props => (
  <Icon viewBox="0 0 24 24" w="full" h="full" color="inherit" {...props}>
    <path
      d="M21.928 11.607c-.202-.488-.635-.605-.928-.633V8c0-1.103-.897-2-2-2h-6V4.61c.305-.274.5-.668.5-1.11a1.5 1.5 0 0 0-3 0c0 .442.195.836.5 1.11V6H5c-1.103 0-2 .897-2 2v2.997l-.082.006A1 1 0 0 0 1.99 12v2a1 1 0 0 0 1 1H3v5c0 1.103.897 2 2 2h14c1.103 0 2-.897 2-2v-5a1 1 0 0 0 1-1v-1.938a1.006 1.006 0 0 0-.072-.455zM5 20V8h14l.001 3.996L19 12v2l.001.005.001 5.995H5zM8.5 10C7.672 10 7 10.895 7 12s.672 2 1.5 2S10 13.105 10 12s-.672-2-1.5-2zm7 0c-.828 0-1.5.895-1.5 2s.672 2 1.5 2S17 13.105 17 12s-.672-2-1.5-2zM8 16h8v2H8z"
      fill="currentColor"
    />
  </Icon>
);
